import { ArticleSortOptionEnum } from "~/enums/ArticleSortOptionEnum";

export class SearchDataModel {
  constructor(
    skip: number = 0,
    limit: number = 0,
    sortBy: number = ArticleSortOptionEnum.DATE
  ) {
    this.skip = skip;
    this.limit = limit;
    this.sortby = sortBy;
  }

  public limit: number;
  public skip: number;
  public sortby: number;
}
